"use client"

import { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ResourcesSection from '../ResourcesSection/ResourcesSection'
import LevelUpAndTrustSection from '../LevelUpAndTrustSection/LevelUpAndTrustSection'
import { motion, useInView } from 'framer-motion';
import Button from '../global-component/DatasheetButtons';
import Link from 'next/link'

function formatDateToLong(dateTimeStr) {
    const date = new Date(dateTimeStr.replace(" ", "T")); // Ensure valid ISO format
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

function AINutrition({ blok }) {
    const levelUpRef = useRef(null);
    const [showVideoModal, setShowVideoModal] = useState(false);

    const handleScrollToLevelUp = () => {
        levelUpRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);

    const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
    const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
    const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
    const isInView4 = useInView(ref4, { once: true, margin: "-100px" });
    const isInView5 = useInView(ref5, { once: true, margin: "-100px" });
    const isInView6 = useInView(ref6, { once: true, margin: "-100px" });
    const isInView7 = useInView(ref7, { once: true, margin: "-100px" });

    const handleDashboardClick = (link = "") => {
        // window.open(link || blok?.Content?.[1]?.link?.cached_url, "_blank");
    };

    return (
        <div className='m-auto bg-asmPageTopBG bg-center bg-cover w-full font-aileron'>
            {/* <AppBar /> */}
            <div className="relative min-h-[1000px] lg:flex flex-col items-center pt-16 lg:pt-24 m-auto">
                {/* Header Section */}
                <div className=" font-aileron py-20 lg:pt-[65px] text-center font-bold max-w-7xl">
                    <h2 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px] px-6 leading-normal">
                        {blok.heading.replace(/\u00A0/g, " ")}
                    </h2>
                    <div className="text-[20px]  m-auto lg:text-[32px] font-normal">
                        {blok.subheading}
                    </div>
                </div>

                {/* Section 2: Big white card, centered */}
                <div className="w-full flex justify-center lg:mt-5 lg:mb-5 mt-0 mb-5 max-w-7xl px-4 lg:px-0">
                    <div className="bg-white rounded-[32px] shadow-custom-xl px-8 py-10 w-full text-center lg:px-[113px] lg:py-20 gap-[30px]">
                        <h3 className="text-2xl lg:text-5xl font-bold mb-4 bg-custom-radial bg-clip-text text-transparent">
                            {blok.SectionTwo?.[0]?.title}
                        </h3>
                        <p className="text-base lg:text-lg text-[#222] mb-2">
                            {blok.SectionTwo?.[0]?.description}
                        </p>
                        <div className="text-base lg:text-lg text-[#222] mt-4">
                            {blok.SectionTwo?.[0]?.ctaText}
                        </div>
                    </div>
                </div>

                {/* Section 3: Icon+text grid, two columns on desktop, one on mobile */}
                <div className="w-full flex justify-center lg:py-20 py-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-12 max-w-7xl w-full px-4 lg:px-6">
                        {blok.SectionThree?.map((item) => (
                            <div key={item._uid} className="flex items-center gap-4">
                                <img src={item.icon.filename} alt="" className="w-7 mt-1" />
                                <span className="text-base lg:text-lg text-left">{item.text}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Section 4: Gradient callout with border */}
                <div className="w-full flex justify-center my-12 px-4 lg:px-0">
                    <div className="w-full max-w-7xl bg-gradient-to-r from-[#5A27E7] to-[#9A509D] rounded-[16px] px-6 py-14 text-center">
                        <span className="text-white font-aileronimage.png font-bold text-base lg:text-2xl">
                            That's why Securin has introduced our "AI Risk Nutrition Labels" - the first structured security report card for AI models – including LLMs like ChatGPT, Grok, and in-house models.
                        </span>
                    </div>
                </div>

                {/* Carousel: Nutrition Label Carousel */}
                <NutritionLabelCarousel images={blok.Carousel} />

                {/* Section 5*/}
                <div className="w-full flex justify-center lg:my-12 my-3">
                    <div className="w-full max-w-7xl px-6 py-14 text-center flex flex-col items-center">
                        <h3 className="text-2xl lg:text-5xl font-bold mb-4 bg-custom-radial bg-clip-text text-transparent">
                            {blok.SectionFive?.[0]?.title}
                        </h3>
                        <p className="text-base lg:text-lg text-[#222] mb-2 max-w-4xl">
                            {blok.SectionFive?.[0]?.description}
                        </p>
                        <div className="w-full max-w-4xl flex justify-center mt-20">
                            <img src={blok.SectionFive?.[0]?.image?.filename} alt="" className="w-full object-cover" />
                        </div>
                    </div>
                </div>

                {/* Section 6*/}
                <div className="w-full flex justify-center my-12 max-w-7xl px-4 lg:px-0">
                    <div className="bg-white rounded-[32px] shadow-custom-xl px-8 py-10 w-full text-center lg:px-[113px] lg:py-20 gap-[30px]">
                        <h3 className="text-2xl lg:text-5xl font-bold mb-4 bg-custom-radial bg-clip-text text-transparent">
                            {blok.SectionSix?.[0]?.title}
                        </h3>
                        <p className="text-base lg:text-lg text-[#222] mb-2">
                            {blok.SectionSix?.[0]?.description}
                        </p>
                        <div className="text-base lg:text-lg text-[#222] mt-4">
                            {blok.SectionSix?.[0]?.ctaText}
                        </div>
                    </div>
                </div>
                {/* Section 7*/}
                <div className="w-full bg-[#EFEBFB] flex justify-center mt-12">
                    <div className="rounded-[32px] px-8 py-10 w-full text-center flex flex-col items-start lg:px-0 lg:py-20 max-w-7xl  gap-20">
                        {/* Right column: Video Card */}
                        <div className='flex flex-col lg:flex-row gap-20'>
                            {blok.SectionSeven?.length > 2 && <div className="flex-2 w-full flex-shrink-0 flex flex-col items-center">
                                <h3 className="text-2xl lg:text-5xl font-bold bg-custom-radial bg-clip-text text-transparent font-aileron leading-normal lg:mb-11 mb-4" style={{ lineHeight: '1.2', textAlign: 'center' }}>
                                    {blok.SectionSeven?.[2]?.title}
                                </h3>
                                <div
                                    className="relative w-full lg:w-[612px] lg:h-[430px] rounded-2xl overflow-hidden cursor-pointer group mb-4"
                                    style={{ aspectRatio: '16/9', background: '#222' }}
                                    onClick={() => setShowVideoModal(true)}
                                >
                                    <img
                                        src={blok.SectionSeven?.[2]?.image?.filename}
                                        alt="Security to Model Video Preview"
                                        className="w-full lg:w-[612px] h-full object-cover rounded-2xl"
                                    />
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="bg-white bg-opacity-70 rounded-full p-3 flex items-center justify-center">
                                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="32" cy="32" r="32" fill="white" fillOpacity="0.7" />
                                                <polygon points="28,22 46,32 28,42" fill="#6C4EE6" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-[#222] text-[18px] lg:text-[24px]  -snug text-center max-w-4xl mt-10">
                                    {blok.SectionSeven?.[2]?.description}
                                </div>
                            </div>}
                        </div>
                        {/* Left column: header, subheader, resource cards */}
                        <div className='flex justify-center gap-20 w-full'>
                            <div className="flex flex-col items-start text-center">
                                <h3 className="text-2xl lg:text-5xl font-bold mb-4 bg-custom-radial bg-clip-text text-transparent text-center w-full">
                                    {blok.SectionSeven?.[0]?.header}
                                </h3>
                                <p className="text-base lg:text-lg text-[#222] mb-6 lg:w-[451px] w-full">
                                    {blok.SectionSeven?.[0]?.subheader}
                                </p>
                                <div className="flex flex-col gap-6 w-full">
                                    <div
                                        className="bg-white shadow-lg rounded-lg flex flex-col items-center text-center px-5 py-5 space-y-4 w-full lg:w-[451px] lg:h-[660px]"
                                    >
                                        <img src={blok.SectionSeven?.[1]?.image?.filename} className="w-full aspect-square object-cover rounded-lg" alt={`Resource`} />
                                        <Link href={"/" + blok.SectionSeven?.[1]?.url?.cached_url} target="_blank" className="text-[#49378F] font-lato font-bold text-lg md:text-xl hover:underline">
                                            {blok.SectionSeven?.[1]?.title}
                                        </Link>
                                        <p className="text-sm md:text-base font-lato text-gray-600">{blok.SectionSeven?.[1]?.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Video Modal */}
                        {showVideoModal && (
                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60" onClick={() => setShowVideoModal(false)}>
                                <div className="bg-white rounded-xl shadow-2xl p-4 max-w-2xl w-full relative" onClick={e => e.stopPropagation()}>
                                    <button className="absolute top-2 right-2 text-2xl font-bold text-gray-700 hover:text-black" onClick={() => setShowVideoModal(false)}>&times;</button>
                                    <div className="w-full aspect-video">
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            src={blok.SectionSeven?.[2]?.url?.cached_url}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/* Section 8*/}
            <div className='bg-[linear-gradient(to_right,_#E5E4F9_0%,_#EFD1F2_100%)] py-[44px] flex flex-col lg:flex-row gap-[40px] justify-center items-center w-full'>
                <img src={blok?.SectionEight?.[0]?.image?.filename} className="object-contain" />
                <h2 className="font-aileron text-[28px] text-center lg:text-start lg:text-[40px] 
                                                  !font-bold bg-custom-radial bg-clip-text 
                                                  text-transparent px-4 lg:px-0 ">
                    {blok?.SectionEight?.[0]?.title}
                </h2>
                <Link href={"/" + blok?.SectionEight?.[0]?.url?.cached_url} className='px-[50px] text-[24px] flex justify-center items-center py-[17.5px] gap-2 w-auto h-auto text-white bg-[#E56717] rounded-[4px]'>
                    {blok?.SectionEight?.[0]?.ctaText}
                </Link>
            </div>
        </div>
    )
}

// Carousel component definition
function NutritionLabelCarousel({ images }) {
    const [centerIdx, setCenterIdx] = useState(2);
    const [cardSize, setCardSize] = useState({ width: 400, height: 580 });
    const containerRef = useRef(null);

    const numberOfCards = 5;

    // Responsive card size
    useEffect(() => {
        const updateSizes = () => {
            const isMobileNow = window.innerWidth < 768;
            setCardSize(isMobileNow
                ? { width: 260, height: 380 }
                : { width: 400, height: 580 }
            );
        };
        updateSizes();
        window.addEventListener('resize', updateSizes);
        return () => window.removeEventListener('resize', updateSizes);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCenterIdx((prev) => (prev + 1) % images.length);
        }, 2500);
        return () => clearInterval(interval);
    }, [images.length]);

    const getIdx = (offsetIdx) => (centerIdx + offsetIdx + images.length) % images.length;

    // Always overlap: offset is a fixed percentage of card width
    const overlapRatio = 0.85; // 85% of card width
    const offset = cardSize.width * overlapRatio;
    const outerMultiplier = 1.5; // brings outer cards closer

    const positions = [
        { scale: 0.7, x: -offset * outerMultiplier, z: 1, opacity: 0.8 },
        { scale: 0.85, x: -offset, z: 2, opacity: 0.9 },
        { scale: 1.1, x: 0, z: 3, opacity: 1 },
        { scale: 0.85, x: offset, z: 2, opacity: 0.9 },
        { scale: 0.7, x: offset * outerMultiplier, z: 1, opacity: 0.8 },
    ];

    return (
        <div
            className="relative w-full flex justify-center items-center py-20 md:py-24 overflow-hidden"
            style={{ minHeight: cardSize.height }}
        >
            <div
                ref={containerRef}
                className="relative max-w-7xl w-full"
                style={{ height: cardSize.height }}
            >
                {positions.map((pos, i) => {
                    const imgIdx = getIdx(i - 2);
                    return (
                        <motion.img
                            key={imgIdx + '-' + centerIdx}
                            src={images[imgIdx].image.filename}
                            alt=""
                            className="absolute left-1/2 top-1/2 rounded-xl shadow-lg"
                            style={{
                                width: cardSize.width * pos.scale,
                                height: cardSize.height * pos.scale,
                                zIndex: pos.z,
                                opacity: pos.opacity,
                                x: `calc(-50% + ${pos.x}px)`,
                                y: '-50%',
                                pointerEvents: pos.z === 3 ? 'auto' : 'none',
                            }}
                            animate={{
                                scale: pos.scale,
                                opacity: pos.opacity,
                                zIndex: pos.z,
                                x: `calc(-50% + ${pos.x}px)`,
                                y: '-50%',
                            }}
                            transition={{ duration: 0.6, type: 'spring' }}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default AINutrition